import { connect, } from 'react-redux';

function baseContainer(mapStateToProps, mapDispatchToProps, mergeProps) {
  return component => connect(
    mapStateToProps,
    mapDispatchToProps,
    mergeProps || null
  )(component);
}

export default baseContainer;
